import { queryOptions, useMutation } from '@tanstack/react-query';

import CodingRepository from '../repositories/codingRepository';
import { ConfigRepository } from '../repositories/configRepository';
import { SupportRepository } from '../repositories/supportRepository';

import { codingKeys } from './query-keys';

export const supportKeys = {
	getSupportUrl: 'getSupportUrl',
	getServerVersion: 'getServerVersion',
	getWorkflowConfig: 'getWorkflowConfig',
	getWorkflowConfigs: 'getWorkflowConfigs',
	getProviderMappingConfigs: 'getProviderMappingConfigs',
};

export const supportUrlQuery = queryOptions({
	queryKey: [supportKeys.getSupportUrl],
	queryFn: SupportRepository.getSupportUrl,
});

export const getServerVerionQuery = () => ({
	queryKey: [supportKeys.getServerVersion],
	queryFn: ConfigRepository.getServerVersion,
});

export const getWorkflowConfigQuery = ({ companyId }) => ({
	queryKey: [supportKeys.getWorkflowConfig, companyId],
	queryFn: () => SupportRepository.getWorkflowConfig({ companyId }),
	enabled: !!companyId,
});

export const getWorkflowConfigsQuery = () => ({
	queryKey: [supportKeys.getWorkflowConfigs],
	queryFn: SupportRepository.getWorkflowConfigs,
});

export const useSaveWorkflowConfigQuery = () => {
	return useMutation({
		mutationFn: SupportRepository.setWorkflowConfig,
	});
};

export const getProviderMappingConfigsQuery = () => ({
	queryKey: [supportKeys.getProviderMappingConfigs],
	queryFn: ConfigRepository.getProviderMappingConfigs,
});

export const getProviderMappingQuery = () => ({
	queryKey: [codingKeys.getProviderMapping],
	queryFn: CodingRepository.getProviderMapping,
});
